import { Callout } from "@octopusdeploy/design-system-components";
import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/ExternalLink";
type RestrictedPermissionsCalloutProps = {
    isVisible: boolean;
};
export const RestrictedPermissionsCallout: React.FC<RestrictedPermissionsCalloutProps> = ({ isVisible }) => {
    const { type, title, content } = restrictedPermissionsCalloutConfig;
    return (<>
            {isVisible && (<Callout title={title} type={type}>
                    {content}
                </Callout>)}
        </>);
};
RestrictedPermissionsCallout.displayName = "RestrictedPermissionsCallout"
export const restrictedPermissionsCalloutConfig = {
    type: "warning",
    title: "Permissions are restricted",
    content: (<>
            Your current license has restricted permissions, which means that all users are able to do everything in the system. Any changes you make to teams and roles will be overridden by this restriction. You can read more about
            <ExternalLink href="RestrictedPermissions"> restricted permissions</ExternalLink> on our website.
        </>),
} as const;
export default RestrictedPermissionsCallout;
